import { render, staticRenderFns } from "./bookDetail.vue?vue&type=template&id=3da025d6&scoped=true&"
import script from "./bookDetail.vue?vue&type=script&lang=js&"
export * from "./bookDetail.vue?vue&type=script&lang=js&"
import style0 from "./bookDetail.vue?vue&type=style&index=0&id=3da025d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da025d6",
  null
  
)

export default component.exports